import ContactsInfoBlock from './ContactsInfoBlock';

export default ContactsInfoBlock;
